import { useState } from 'react';
import { toast } from 'react-toastify';
import Modal from '../../../components/Modal';
import message from '../../../constant/message';
import Button from '../../../components/Common/Button';
import LenderUgroService from '../../../services/lender';
import { objectsForEach } from '../../../common/objectToArray';


const AddDRFModal = ({ userType, state, toggleModal, leadId, selectedLender, reloadTable, isMachinerySup, mstTransType, data }) => {
	const [loading, setLoading] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [accName, setAccName] = useState(data?.acc_name)
    const [assetAmt, setAssetAmt] = useState(data?.asset_amt)
    const [disbursedAmount, setDisbursedAmount] = useState(data?.finance_amount)
    const [bankName, setBankName] = useState(data?.bank_name)
    const [ifscCode, setIfscCode] = useState(data?.ifsc)
    const [bankAccID, SetBankAccID] = useState(data?.bank_acc_id)
    const [transType, SetTransType] = useState(mstTransType[data?.txn_type] ?? (Number.isInteger(data?.txn_type)? '' : data?.txn_type))
    const [drfDate, setDrfDate] = useState(data?.date)
    const [city, setCity] = useState(data?.city)
    const [address, setAddress] = useState(data?.address)
	const [errors, setErrors] = useState();

	const toggleConfirmModal = () => {
		setShowConfirmModal(!showConfirmModal);
	};

    const formSubmitHandler = async () => {
		setLoading(true);
        let formData = new FormData();
        accName && formData.append('acc_name', accName)
        assetAmt && formData.append('asset_amt', assetAmt)
        disbursedAmount && formData.append('finance_amount', disbursedAmount)
        bankName && formData.append('bank_name', bankName)
        ifscCode && formData.append('ifsc', ifscCode)
        bankAccID && formData.append('bank_acc_id', bankAccID)
        transType && formData.append('txn_type', transType)
        drfDate && formData.append('date', drfDate)
        city && formData.append('city', city)
        address && formData.append('address', address)
        formData.append('is_machinery_sup', isMachinerySup)

		await LenderUgroService.SaveDrfDetail({ formData, leadId, lenderId:selectedLender }).then((response) => {
			setLoading(false)
            toast.success(response?.data?.messages?.success?.others[0])
            toggleModal();
			setShowConfirmModal(false);
			reloadTable(leadId);
        }).catch((err) => {
			setLoading(false)
			setShowConfirmModal(false);
            toast.error(err?.response?.data?.messages?.error?.form?.[0] || err?.response?.data?.messages?.error?.others?.[0])
            setErrors(err?.response?.data?.messages?.error?.fields)
        });
    }

	return (
		<>
		<Modal state={state} closeModal={toggleModal} style={{ width: "450px" }} removeBorderSpace={true}>
			<div className="modal-header-container">
				<div className="modal-title">Supplier DRF Info</div>
				<div className="closeModalView" onClick={toggleModal}>
					<span className="closeModalIcon">x</span>
				</div>
			</div>
			<div className="p-4 modalData">
				{/* <form onSubmit={formSubmitHandler}> */}
					<div style={{maxHeight: '400px', overflowY: 'scroll', overflowX: 'clip'}}>
					<div class='form-group'>
						<label>Name <tt>*</tt></label>
						<div class='row'>
							<div class='col-12'>
								<input
									class='form-control custom-form-control'
									value={accName}
                                    name="acc_name"
									onChange={(e) => setAccName(e.target.value)}
                                    maxLength={50}
									required
								/>
							</div>
							{errors && (
								<p className='mb-0 text-danger' style={{margin: '-8px 0 0 17px' }}>{errors?.acc_name?.[0]}</p>
							)}
						</div>
					</div>
					<div class='form-group'>
						<label>Asset Amount <tt>*</tt></label>
						<div class='row'>
							<div class='col-12'>
								<input
									class='form-control custom-form-control'
									value={assetAmt}
                                    name="asset_amt"
									onChange={(e) => setAssetAmt(e.target.value.replace(/[^0-9]/g, ''))}
                                    maxLength={15}
									required
								/>
							</div>
							{errors && (
								<p className='mb-0 text-danger' style={{margin: '-8px 0 0 17px' }}>{errors?.asset_amt?.[0]}</p>
							)}
						</div>
					</div>
					<div class='form-group'>
						<label>Disbursed Amount <tt>*</tt></label>
						<div class='row'>
							<div class='col-12'>
								<input
									type='text'
									class='form-control custom-form-control'
                                    name="amount"
									value={disbursedAmount}
									onChange={(e) => setDisbursedAmount(e.target.value.replace(/[^0-9]/g, ''))}
                                    maxLength={15}
									required
								/>
							</div>
							{errors && (
								<p className='mb-0 text-danger' style={{margin: '-8px 0 0 17px' }}>{errors?.finance_amount?.[0]}</p>
							)}
						</div>
					</div>
					<div class='form-group'>
						<label>Bank Name <tt>*</tt></label>
						<div class='row'>
							<div class='col-12'>
								<input
									type='text'
									className='form-control'
									name='bank_name'
									value={bankName}
									onChange={(e) => setBankName(e.target.value)}
                                    maxLength={50}
									required
								/>
							</div>
							{errors && (
								<p className='mb-0 text-danger' style={{margin: '-8px 0 0 17px' }}>{errors?.bank_name?.[0]}</p>
							)}
						</div>
					</div>
					<div class='form-group'>
						<label>IFSC <tt>*</tt></label>
						<div class='row'>
							<div class='col-12'>
								<input
									class='form-control custom-form-control'
									value={ifscCode}
                                    name="ifsc"
									onChange={(e) => setIfscCode(e.target.value)}
                                    maxLength={11}
									required
								/>
							</div>
							{errors && (
								<p className='mb-0 text-danger' style={{margin: '-8px 0 0 17px' }}>{errors?.ifsc?.[0]}</p>
							)}
						</div>
					</div>
					<div class='form-group'>
						<label>Bank Account Number <tt>*</tt></label>
						<div class='row'>
							<div class='col-12'>
								<input
									type='text'
									className='form-control'
									name='bank_acc_id'
									value={bankAccID}
									onChange={(e) => SetBankAccID(e.target.value)}
                                    maxLength={25}
									required
								/>
							</div>
							{errors && (
								<p className='mb-0 text-danger' style={{margin: '-8px 0 0 17px' }}>{errors?.bank_acc_id?.[0]}</p>
							)}
						</div>
					</div>
                    <div class='form-group'>
						<label>Transaction Type (NEFT, RTGS, Cheque)<tt>*</tt></label>
						<div class='row'>
							<div class='col-12'>
							<input
								type='text'
								className='form-control'
								name='trans_type'
								value={transType}
								onChange={(e) => SetTransType(e.target.value)}
								maxLength={25}
								required
							/>
							{/* <select
								class='form-control custom-form-control'
								onChange={(e) => SetTransType(e.target.value)}
								value={transType}
							>
								<option value={''}>Select Trans Type</option>
								{objectsForEach(mstTransType, 'STRING_VAL').map(({id, value})=>
									<option value={id}>{value}</option>
								)}
							</select> */}
							</div>
							{errors && (
								<p className='mb-0 text-danger' style={{margin: '-8px 0 0 17px' }}>{errors?.txn_type?.[0]}</p>
							)}
						</div>
					</div>
                    <div class='form-group'>
						<label>DRF Date <tt>*</tt></label>
						<div class='row'>
							<div class='col-12'>
								<input
									type='Date'
									className='form-control'
									name='date'
									value={drfDate}
									onChange={(e) => setDrfDate(e.target.value)}
									required
								/>
							</div>
							{errors && (
								<p className='mb-0 text-danger' style={{margin: '-8px 0 0 17px' }}>{errors?.date?.[0]}</p>
							)}
						</div>
					</div>
					<div class='form-group'>
						<label>Supplier City <tt>*</tt></label>
						<div class='row'>
							<div class='col-12'>
								<input
									type='text'
									class='form-control custom-form-control'
                                    name="city"
									value={city}
									onChange={(e) => setCity(e.target.value)}
                                    maxLength={50}
									required
								/>
							</div>
							{errors && (
								<p className='mb-0 text-danger' style={{margin: '-8px 0 0 17px' }}>{errors?.city?.[0]}</p>
							)}
						</div>
					</div>
					<div class='form-group'>
						<label>Supplier Address</label>
						<div class='row'>
							<div class='col-12'>
								<input
									type='text'
									class='form-control custom-form-control'
                                    name="address"
									value={address}
									onChange={(e) => setAddress(e.target.value)}
                                    maxLength={100}
									required
								/>
							</div>
							{errors && (
								<p className='mb-0 text-danger' style={{margin: '-8px 0 0 17px' }}>{errors?.address?.[0]}</p>
							)}
						</div>
					</div>
					</div>
					<div class='d-flex align-items-center justify-content-center mt-2'>
						<button type='submit' class='btn btn-custom' disabled={loading} onClick={toggleConfirmModal}>
							Save
						</button>
						<button
							type='button'
							class='btn btn-outline-custom ml-2'
							data-dismiss='modal'
							onClick={toggleModal}
						>
							Cancel
						</button>
					</div>
				{/* </form> */}
			</div>
		</Modal>
		<Modal state={showConfirmModal} closeModal={toggleConfirmModal} style={{width: '440px'}}>
			<div>
				<p className='font-weight-bold text-center'>
					Disbursement will be done in this Machinery Supplier Account. Please confirm to save the Machinery Supplier Account details.
				</p>
				<br/>
				<div className='d-flex align-items-center justify-content-center'>
					<Button clickHandler={formSubmitHandler} classNames='btn-custom small mr-2' disabled={loading}>
						{loading ? <div className='loader' /> : 'Yes'}
					</Button>
					<Button
						clickHandler={toggleConfirmModal}
						classNames='btn-custom small'
					>
						No
					</Button>
				</div>
			</div>
		</Modal>
		</>
	);
};

export default AddDRFModal;
